<script lang="ts" setup>

	import DeliveryAddressDetail from '@/components/deliveryaddress/DeliveryAddressDetail.vue';
	import {useI18n} from 'vue-i18n';
	import {type DeliveryAddress} from 'dummen-shared';
	import {computed} from 'vue';

	const {t} = useI18n();

	const props = defineProps<{
		selectedDeliveryAddressId: string | null;
		deliveryAddresses: DeliveryAddress[];
		changeDeliveryAddressButtonDisabled: boolean;
	}>();

	const emit = defineEmits(['on-delivery-address-change']);

	const selectedDeliveryAddress = computed(() => {
		if (!props.deliveryAddresses) {
			return null;
		}

		const foundDeliveryAddress = props.deliveryAddresses.find((deliveryAddress: DeliveryAddress) => deliveryAddress.id === props.selectedDeliveryAddressId);

		return foundDeliveryAddress ?? null;
	});

	const changeDeliveryAddress = () => {
		emit('on-delivery-address-change');
	};

</script>

<template>
	<div class="input-wrapper">
		<div class="input-wrapper modal-wrapper__address">
			<label>
				{{ t('shoppingcart.modal.createpo.content.selectDeliveryAddress.label') }}:
			</label>

			<delivery-address-detail :delivery-address="selectedDeliveryAddress">

				<template v-slot:noDeliveryAddress>
					<p class="error">
						{{ t('shoppingcart.modal.createpo.content.noDeliveryAddressFound.error.text') }}
					</p>
				</template>

				<template v-slot:button>
					<button :disabled="changeDeliveryAddressButtonDisabled"
					        class="button--text modal-wrapper__address__change"
					        type="button"
					        @click="changeDeliveryAddress">

						<img alt="" height="18" src="/assets/images/build/icons-mydummen/edit.svg"
						     width="18" />
						{{ t('shoppingcart.modal.createpo.content.changeDeliveryAddress.text') }}
					</button>
				</template>

			</delivery-address-detail>
		</div>
	</div>
</template>

<style scoped>
	.modal-wrapper__address {
		position: relative;
	}
</style>
